module.exports = __webpack_public_path__ + "img/03.ea95da22.jpg";